var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"not-found"},[_c('h1',{staticClass:"not-found__title"},[_vm._v(_vm._s(_vm.$t("errors.404")))]),_c('h2',{staticClass:"not-found__subtitle"},[_vm._v(_vm._s(_vm.$t("errors.page-not-found")))])])}
var staticRenderFns = []

export { render, staticRenderFns }